import React from "react";
import { ProgressBar, ProgressBarType } from "@geotab/zenith";
import { RiskPillText } from "../riskFactorsPill/riskFactorsPill";

interface IBenchmarkBar {
    percent: number;
    rating: string;
}

const getBarProps = (rating: string): { type: ProgressBarType; class: string } => {
    switch (rating) {
        case RiskPillText.Best:
            return { type: ProgressBarType.High, class: "benchmarkBar benchmarkBar--high" };
        case RiskPillText.Underperforming:
            return { type: ProgressBarType.Average, class: "benchmarkBar benchmarkBar--underperforming"};
        case RiskPillText.AtRisk:
            return { type: ProgressBarType.Low, class: "benchmarkBar benchmarkBar--low" };
        default:
            return { type: ProgressBarType.Average, class: "benchmarkBar benchmarkBar--moderate" };
    }
};

export const BenchmarkBar: React.FC<IBenchmarkBar> = ({ percent, rating }) => {
    let barProps = getBarProps(rating);
    return (
        <div className="benchmarkBar__container">
            <ProgressBar now={percent} type={barProps.type} className={barProps.class} />
            <div className="benchmarkBar__icon-container">
                <svg className="svgIcon geotabButtonIcons benchmarkBar__icon">
                    <use xlinkHref="#drive-safety-benchmark-triangle"></use>
                </svg>
            </div>
        </div>
    );
};
